import { getCodes } from '../../../helpers/api'

export default {
	getInviteCodes: ({ commit }, token) => {
		commit('SET_LOADING', true)
		return getCodes(token).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_CODES', data.codes)
			return true
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	}
}
